import React, { useRef, useState } from 'react';
import { QRCodeCanvas } from 'qrcode.react';
import Icon from '../AppIcon';

const QRShareRow = ({ profileUrl, nesolearnId }) => {
  const qrWrapperRef = useRef(null);
  const [copied, setCopied] = useState(false);

  const handleDownloadQR = () => {
    const canvas = qrWrapperRef.current?.querySelector('canvas');
    if (!canvas) return;
    const link = document.createElement('a');
    link.download = `${nesolearnId || 'nesolearn-id'}-qr.png`;
    link.href = canvas.toDataURL('image/png');
    link.click();
  };

  const handleCopyLink = async () => {
    try {
      await navigator.clipboard.writeText(profileUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Copy failed:', err);
    }
  };

  const handleNativeShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({ title: `${nesolearnId} on Nesolearn`, url: profileUrl });
      } catch (err) {
        if (err?.name !== 'AbortError') console.error('Share failed:', err);
      }
    } else {
      handleCopyLink();
    }
  };

  const encodedUrl = encodeURIComponent(profileUrl);
  const shareText = encodeURIComponent(`Check out ${nesolearnId}'s Nesolearn profile`);
  const waHref = `https://wa.me/?text=${shareText}%20${encodedUrl}`;
  const twitterHref = `https://twitter.com/intent/tweet?text=${shareText}&url=${encodedUrl}`;
  const linkedinHref = `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`;

  return (
    <div className="flex flex-col items-center gap-4">
      <div ref={qrWrapperRef} className="p-3 bg-white rounded-lg">
        <QRCodeCanvas value={profileUrl} size={140} level="M" includeMargin={false} />
      </div>

      <div className="flex items-center gap-2 flex-wrap justify-center">
        <button onClick={handleDownloadQR} className="flex items-center gap-1.5 px-3 py-2 rounded-lg bg-muted hover:bg-muted/70 text-sm text-foreground transition-smooth">
          <Icon name="Download" size={14} /> Download QR
        </button>

        <button onClick={handleCopyLink} className="flex items-center gap-1.5 px-3 py-2 rounded-lg bg-muted hover:bg-muted/70 text-sm text-foreground transition-smooth">
          <Icon name={copied ? 'Check' : 'Copy'} size={14} /> {copied ? 'Copied!' : 'Copy Link'}
        </button>

        <button onClick={handleNativeShare} className="flex items-center gap-1.5 px-3 py-2 rounded-lg bg-accent text-white hover:bg-accent/90 text-sm transition-smooth">
          <Icon name="Share2" size={14} /> Share
        </button>
      </div>

      <div className="flex items-center gap-3">
        <a href={waHref} target="_blank" rel="noopener noreferrer" className="w-8 h-8 rounded-full bg-muted hover:bg-muted/70 flex items-center justify-center transition-smooth" aria-label="Share on WhatsApp">
          <Icon name="MessageCircle" size={15} />
        </a>
        <a href={twitterHref} target="_blank" rel="noopener noreferrer" className="w-8 h-8 rounded-full bg-muted hover:bg-muted/70 flex items-center justify-center transition-smooth" aria-label="Share on X">
          <Icon name="Twitter" size={15} />
        </a>
        <a href={linkedinHref} target="_blank" rel="noopener noreferrer" className="w-8 h-8 rounded-full bg-muted hover:bg-muted/70 flex items-center justify-center transition-smooth" aria-label="Share on LinkedIn">
          <Icon name="Linkedin" size={15} />
        </a>
      </div>
    </div>
  );
};

export default QRShareRow;